import {type ActionTree} from 'vuex';

const actions: ActionTree<LightBoxState, RootState> = {

    open({commit}, payload)
    {
        commit('setImages', payload.images);
        commit('setCurrent', payload.current)
    },

    close({commit})
    {
        commit('setImages', []);
        commit('setCurrent', 0)
    },

    next({commit, state})
    {
        commit('setCurrent', Math.min(state.current + 1, state.images.length) );
    },

    previous({commit, state})
    {
        commit('setCurrent', Math.max(state.current - 1, 1) );
    }

};

export default actions;